import { useState, useEffect, useContext, useMemo, useCallback } from 'react'
import { useLocation, useParams, useNavigate } from 'react-router-dom'

import { AppContext } from '/providers/app-context'
import { getPass } from '/providers/passes-api'

import ManagePassSubpageLayout from '/components/passes/manage-pass-subpage-layout'
import HelpText from '/help/pass-details'

import { PassEditContent } from '/components/passes/editor.jsx'

const PassEditor = () => {

  const navigate = useNavigate()
  const location = useLocation()

  const { templateId, passId } = useParams()
  const { apiSource, apiKey, templates, passes, setPasses } = useContext(AppContext)
  const [pass, setPass] = useState(() => location.state?.pass ?? passes.find(item => item.template_id === templateId && item.pass_id === passId))
  const template = useMemo(() => { return templates.filter(t => t.template_id === templateId)[0] }, [templates, templateId])

  const getPassData = useCallback(async () => {
    const p = await getPass({ apiSource, apiKey, passId })
    if (p.ok === false || !p.pass) return navigate("/templates")
    setPasses(current => {
      const idx = current.findIndex(item => item.template_id === templateId && item.pass_id === passId)
      if (idx < 0) return [...current, p.pass]
      const next = [...current]
      next[idx] = p.pass
      return next
    })
    setPass(p.pass)
  }, [apiKey, apiSource, navigate, passId, setPasses, templateId])

  useEffect(() => {
    if (pass) return
    getPassData()
  }, [getPassData, pass])

  const setLocationStatePass = pass => {
    setPass(pass)
    setPasses(current => {
      const idx = current.findIndex(item => item.template_id === templateId && item.pass_id === passId)
      if (idx < 0) return [...current, pass]
      const next = [...current]
      next[idx] = pass
      return next
    })
    navigate(location.pathname, { replace: true, state: { ...location.state, pass } })
  }

  return (
    <ManagePassSubpageLayout title={`Edit Pass (${pass?.pass_id})`} HelpText={HelpText} heading={`${pass?.pass_id} ${pass?.mode === "test" ? " [test]" : ""}`} template={template} pass={pass} onClose={() => navigate(`/templates/${templateId}/passes`)}>
      <Content templateId={templateId} pass={pass} getPass={getPassData} setPass={setLocationStatePass} />
    </ManagePassSubpageLayout>
  )
}

export default PassEditor

const Content = ({ templateId, pass, setPass }) => {
  return <PassEditContent pass={pass} templateId={templateId} setPass={setPass} />
}
